import { render, staticRenderFns } from "./ParcLyonFerme.vue?vue&type=template&id=e185d634&"
import script from "./ParcLyonFerme.vue?vue&type=script&lang=js&"
export * from "./ParcLyonFerme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports